const translationsDE = {
  adsTitle: 'Werbung',
  and: 'und',
  'author.by': 'von',
  back: 'Zurück',
  'blickTVStory.chapterTitle': 'Das hast du verpasst',
  'blickTVStory.goToLive': 'Zu Live springen',
  'blickTVStory.live': 'Live',
  'blickTVStory.restartCurrentChapter': 'Beitrag von vorne schauen',
  close: 'Schliessen',
  'commenting.answer': 'Antworten',
  'commenting.answerPlaceholder': 'Schreiben Sie eine Antwort...',
  'commenting.answerPlaceholderEmailOnly':
    'Vervollständigen Sie Ihr Profil hier, um zu antworten...',
  'commenting.answerPlaceholderNotLoggedIn':
    'Einloggen und eine Antwort schreiben...',
  'commenting.authorType.admin': 'Administrator',
  'commenting.authorType.admin.female': 'Administratorin',
  'commenting.authorType.journalist': 'Journalist',
  'commenting.authorType.journalist.female': 'Journalistin',
  'commenting.authorType.moderator': 'Moderator',
  'commenting.authorType.moderator.female': 'Moderatorin',
  'commenting.authorType.user': 'User',
  'commenting.cancel': 'Abbrechen',
  'commenting.commentingRulesText': 'Hier gehts zu den ',
  'commenting.commentingRulesLinkText': 'Kommentarregeln.',
  'commenting.commentPlaceholder': 'Schreiben Sie einen Kommentar...',
  'commenting.commentPlaceholderEmailOnly':
    'Vervollständigen Sie Ihr Profil hier, um zu kommentieren...',
  'commenting.commentPlaceholderNotLoggedIn':
    'Einloggen und einen Kommentar schreiben...',
  'commenting.delete': 'Löschen',
  'commenting.deleteConfirmation':
    'Wollen Sie diesen Kommentar wirklich löschen?',
  'commenting.deletedUserName': 'Dieser Nutzer hat das Konto gelöscht',
  'commenting.loadMoreAnswers': 'Weitere Antworten anzeigen',
  'commenting.loadMoreComments': 'Weitere Kommentare anzeigen',
  'commenting.noAvailableComments': 'Derzeit sind keine Kommentare verfügbar.',
  'commenting.numberOfCharactersLeft':
    'Noch {{numberOfCharacters}} Zeichen übrig',
  'commenting.numberOfCharactersOverflow':
    '{{numberOfCharacters}} Zeichen zuviel',
  'commenting.oneCharacterLeft': 'Noch 1 Zeichen übrig',
  'commenting.oneCharacterOverflow': '1 Zeichen zuviel',
  'commenting.postCommentSentMessage':
    'Besten Dank, ihr Kommentar wird überprüft.',
  'commenting.postSubmit': 'Kommentieren',
  'commenting.report': 'Melden',
  'commenting.reportTitle': 'Grund fürs Melden',
  'commenting.reportedMessage': 'Besten Dank für Ihre Meldung.',
  'commenting.title.all': 'Alle Kommentare',
  'commenting.title.top': 'Ausgewählte Stimmen',
  'commenting.to': 'An',
  'config.gdprTitle': 'Datenschutz',
  dossier: 'Dossier',
  'errorPage.errorStatus': 'Fehler {{errorStatus}}',
  'errorPage.helpMessage':
    'Nutzen Sie die Navigation oben um diesen oder einen anderen Artikel zu finden.',
  'errorPage.pageNotFound': 'Leider existiert diese Seite nicht',
  'errorPage.unknownErrorMessage': 'Ein Fehler ist aufgetreten',
  'footer.ringierFooterTitle': 'Mehr von Ringier AG',
  'formIO.loginRequiredButtonText': 'Anmelden',
  'formIO.loginRequiredText': 'Bitte melden Sie sich für eine Teilnahme an!',
  'formIO.noEmailOnlyRequiredButtonText': 'Zum Profil',
  'formIO.noEmailOnlyRequiredText':
    'Vervollständigen Sie Ihr Profil, um mitzumachen',
  'formIO.submissionMessage': 'Vielen Dank für Ihre Teilnahme!',
  'gallery.closeFullscreen': 'Vollbild schliessen',
  'immo.title': 'Traumimmobilie finden',
  lastUpdated: 'Aktualisiert',
  less: 'Weniger',
  lessThanMinute: 'vor 1 Minute',
  lessThanNMinutes: 'vor {{diffMinutes}} Minuten',
  'liveEvent.cancelled': 'Gestrichen',
  'liveEvent.finished': 'Beendet',
  'liveEvent.lap': 'Lap',
  'liveEvent.live': 'LIVE',
  'liveEvent.skiFirstRun': '1. Lauf',
  'liveEvent.skiSecondRun': '2. Lauf',
  'livecenter.live': 'Live',
  'livecenter.sporttip': 'Sporttip',
  'livecenter.title': 'Live-Center',
  'login.logout': 'Abmelden',
  'login.myAccount': 'Mein Konto',
  'lotto.chf': 'CHF',
  'lotto.drawingFrom': 'Ziehung vom {{drawDate}}',
  'lotto.luckyNumber': '+ Glücks-Zahl',
  'lotto.nextDraw': 'Nächste Ziehung: {{nextDate}}',
  'lotto.nextJackpot': 'Nächster Jackpot',
  'lotto.nowPlaying': 'Jetzt spielen',
  'lotto.numberOfWinners': 'Anzahl Gewinner',
  'lotto.prizeCategories': 'Gewinnränge',
  'lotto.profit': 'Gewinn',
  'matchStatus.afterExtraTime': 'Nach Verlängerung',
  'matchStatus.afterPenalty': 'Nach Penaltyschiessen',
  'matchStatus.calledOff': 'Abgesagt',
  'matchStatus.cancelled': 'Abgebrochen',
  'matchStatus.ended': 'Beendet',
  'matchStatus.interrupted': 'Unterbruch',
  'matchStatus.overtime': 'Verlängerung',
  'matchStatus.penaltiesRunning': 'Penaltyschiessen',
  more: 'Mehr',
  next: 'Weiter',
  'optOut.catchword': 'Datenschutz',
  'optOut.checkbox.in':
    'Das Ringier Tracking-Tool ist derzeit deaktiviert. Klicken Sie hier, um es zu aktivieren',
  'optOut.checkbox.out':
    'Das Ringier Tracking-Tool ist derzeit aktiviert. Klicken Sie hier, um es zu deaktivieren',
  'optOut.cmpOverlayHint':
    'Um die Einstellungen zur Bearbeitung ihrer Daten zu ändern, ',
  'optOut.cmpOverlayLink': 'klicken Sie hier.',
  'optOut.hint':
    'Sie können hier bestimmen, ob Sie bestimmte Technologien wie das Ringier Tracking-Tool deaktivieren möchten.',
  'optOut.title': 'Ihre Einstellungen',
  published: 'Publiziert',
  'published.at': 'um',
  'recipe.ingredients': 'Zutaten',
  'recipe.portions': 'Portionen',
  'recipe.nutrition': 'Nährwert / Person',
  'recipe.prepTime': 'Zubereitungs-Zeit',
  'recipe.cookTime': 'Kochzeit',
  'recipe.instructions': 'Zubereitung',
  'recipe.step': 'Schritt',
  'recommendation.title': 'Das könnte dich auch interessieren',
  'scribble.failed':
    'Der Newsticker konnte nicht geladen werden. Laden Sie den Artikel neu, um es erneut zu probieren.',
  'scribble.failedBolded': 'Hoppla! ',
  'scribble.loadMore': '{{numberOfItems}} weitere Einträge',
  'scribble.loadOneMore': 'Ein weiterer Eintrag',
  'scribble.loading': 'Newsticker lädt...',
  'scribble.loadingEntry': 'Lädt Liveticker-Eintrag...',
  'scribble.topPost': 'Top-Beitrag',
  'search.defaultButtonTitle': 'Suchen',
  'search.description':
    'Melden Sie sich kostenlos an und erhalten Sie uneingeschränkten Zugang zu allen Inhalten von Blick.ch.',
  'search.errorMessage':
    'Die Suche ist momentan nicht verfügbar. Bitte versuchen Sie es in einigen Augenblicken noch einmal.',
  'search.input': 'Suche...',
  'search.loading': 'Suche lädt...',
  'search.moreInfoLabel': 'Mehr erfahren',
  'search.noResultsExplanation': 'Keine Suchergebnisse gefunden',
  'search.of': 'von',
  'search.onlyOneSearchResult': 'Suchergebnis',
  'search.page': 'Seite',
  'search.searchResults': 'Suchergebnissen',
  'search.title': 'Sie wollen mehr sehen?',
  'search.toLoginLabel': 'Anmelden',
  shareMessage: 'Geteilt über Blick',
  'social.copyToast': 'Link kopiert',
  'sportTable.goalDiffTotal': 'TD',
  'sportTable.matchesTotal': 'SP',
  'sportTable.name': 'Mannschaft',
  'sportTable.pointsTotal': 'PT',
  submit: 'Senden',
  'topList.title': 'Meistgelesen',
  'topStories.defaultTitle': 'Top-Themen',
} as const

export type TranslationsDE = typeof translationsDE

export default translationsDE
